<template>
  <div class="wg-row" style="align-items:center;flex-wrap:nowrap;">
   <img 
        v-if="!isSynchronized" 
        class="com-anm22-app-img-fixed-height-s"
        :src="$anm22.icons.getWorldIcon('offline')" 
        style="margin-right:5px;width:20px;height:20px;"
        :title="$anm22.strLang(lang, 'Not synchronized', 'Non sincronizzato')"
      >
    <!-- Modale per la cancellazione task -->
    <wg-modal v-if="deleteTaskDialog" @closeModal="closeDeleteDialog">
      <div class="wg-row" style="justify-content:center;" slot="body">
        <div class="com-anm22-app-text-xl">
          {{ $anm22.strLang(lang, 'Delete task?', 'Cancellare task?') }}
        </div>
        <div class="vertical-height-div" style="height:20px;"></div>
        <div class="wg-row" style="align-items:center;justify-content:center;">
          <input 
              type="button" 
              class="small com-anm22-button-blue" 
              :value="$anm22.strLang(lang, 'OK', 'OK')" 
              @click="deleteTask">
          <div class="com-anm22-app-horizontal-space" style="width:20px;"></div>
          <input 
              type="button" 
              class="small com-anm22-button-red" 
              :value="$anm22.strLang(lang, 'Cancel', 'Annulla')" 
              @click="closeDeleteDialog">
        </div>
      </div>
    </wg-modal>
    
    <template v-if="canEdit">
      <div
        class="com-anm22-app-text-xxl"
        style="padding-right:5px;overflow:hidden;white-space:normal;text-overflow:ellipsis;">
        <div
          class="hidden-input"
          v-show="!editing"
          @click="editing = true;$nextTick(() => $refs.titleInput.focus())"
        >{{ taskName }}<div style="flex-basis:100%;height:0;"></div></div>
        <input
          v-show="editing"
          ref="titleInput"
          class="com-anm22-app-input-text"
          type="text"
          style="font-size: 16px !important;"
          v-model="taskName"
          @change="saveTask"
          @blur="editing = !editing"
        >
        <div class="task-id" @click="copyCodeToClipboard()">TK-{{task.idWorldTask.toString(16).toUpperCase()}}</div>
      </div>
    </template>
    <div
      v-else
      class="com-anm22-app-text-xxl"
      style="padding-right:5px;overflow:hidden;white-space:normal;text-overflow:ellipsis;">
      <div>{{ taskName }}<div style="flex-basis:100%;height:0;"></div></div>
      <div class="task-id" @click="copyCodeToClipboard()">TK-{{task.idWorldTask.toString(16).toUpperCase()}}</div>
    </div>
    <!-- Tasto cancellazione task -->
    <div 
        v-if="canDelete"
        class="display-flex com-anm22-button-red delete-button"
        style="margin-left:10px;"
        @click="openDeleteDialog()">
      <img 
          class="com-anm22-app-img-fixed-height-m"
          :src="$anm22.icons.getWorldIcon('deleteBinWhite')">
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    taskId: [Number, String]
  },
  data() {
    return {
      editing: false,
      deleteTaskDialog: false,
      taskName : ''
    }
  },
  computed:{
    ...mapState({
      lang: state => state.lang,
      user: state => state.auth.user
    }),
    isSynchronized() {
      return this.$store.getters['offline/isSynchronized'](this.$anm22.MD5('WorldTask' + this.taskId));
    },
    task() {
      return this.$store.getters['tasks/get'](this.taskId);
    },
    project() {
      return this.$store.getters['projects/get'](this.task.project);
    },
    userPermission() {
      return this.$store.getters["employments/getPermByProject"](this.project);
    },
    licenses() {
      return this.$store.getters["employments/getByUser"](this.user.idWorldUser)
        .filter(e => this.project.developers.includes(e.work))
        .map(e => this.$store.getters["licenses/getByWork"](e.work))
        .filter(l => l);
    },
    canEdit() {
      return this.licenses
        .filter(l => (l.config.tasks && l.config.tasks.tasks && l.config.tasks.tasks['edit-rules']) )
        .reduce((result, l) => result && 
          this.$anm22[l.config.tasks.tasks['edit-rules']](this, this.task)
        , true);
    },
    canDelete() {
      return this.licenses
        .filter(l => (l.config.tasks && l.config.tasks.tasks && l.config.tasks.tasks['delete-rules']) )
        .reduce((result, l) => result && 
          this.$anm22[l.config.tasks.tasks['delete-rules']](this, this.task)
        , true);
    },
  },
  methods: {
    async saveTask() {
      this.task.name = this.taskName;
      try {
        const response = await this.$http
          .post('task/edit', {
            projectId: this.task.project,
            task: this.task
          }, {
            withCredentials: true
          });
        //Salvo in db locale i nuovi dati
        /*
        this.$store.dispatch('tasks/update', {
          vlf: this.$vlf('tasks'), objs: response.data.tasks
        })
        */
      } catch(e) {
        //TO-DO salvataggio offline per successiva sync
        Promise.all([
          this.$store.dispatch('tasks/update', {
            vlf: this.$vlf('tasks'), objs: [this.task]
          }),
          this.$store.dispatch('offline/saveSyncTuple', {
            _vue: this,
            _class: "WorldTask",
            _table: "tasks",
            mode: 'edit',
            type: 'obj',
            obj: this.task
          }),
          // this.$anm22.saveSyncTuple(this, 'WorldTask', 'edit', this.task)
        ]);
      }
    },
    openDeleteDialog() {
      this.deleteTaskDialog = true;
    },
    closeDeleteDialog() {
      this.deleteTaskDialog = false;
    },
    async deleteTask() {
      this.closeDeleteDialog();
      try {
        await this.$http
          .post("task/delete", {
            projectId: this.task.project,
            taskId: this.task.idWorldTask
          }, {
            withCredentials: true
          });
        this.$anm22.eventBus.$emit('wg-modal-close');
        //Cancello da indexedDB e dallo stato
        this.$store.dispatch('tasks/delete', { vlf: this.$vlf('tasks'), obj: this.task});
      } catch(e) {
        this.$anm22.eventBus.$emit('wg-modal-close');
        /* Recupero l'oggetto dal db e poi lo elimino la tupla nel db locale 
          e inserisco la modifica tra gli update di sync */
        this.$store.dispatch('offline/saveSyncTuple', {
          _vue: this,
          _class: "WorldTask",
          _table: "tasks",
          mode: 'delete',
          type: 'obj',
          obj: this.task
        });
        // this.$anm22.saveSyncTuple(
        //   this,
        //   "WorldTask",
        //   'delete',
        //   this.task
        // );
        // Rimuovo le dipendenze
        const tasks = this.$store.getters['tasks/getByProject'](this.task.project);
        tasks.forEach(t => {
          if(t.fts.includes(this.task.idWorldTask)) {
            t.fts.splice(t.fts.indexOf(this.task.idWorldTask), 1);
            this.$store.dispatch('tasks/update', {
              vlf: this.$vlf('tasks'), objs: [t]
            });
            this.$store.dispatch('offline/saveSyncTuple', {
              _vue: this,
              _class: "WorldTask",
              _table: "tasks",
              mode: 'edit',
              type: 'obj',
              obj: t
            });
            // this.$anm22.saveSyncTuple(
            //   this,
            //   "WorldTask",
            //   'edit',
            //   t
            // );
          }
        });
        this.$store.dispatch('tasks/delete', { vlf: this.$vlf('tasks'), obj: this.task });
      }
    },
    copyCodeToClipboard() {
      this.$anm22.copyTextToClipboard('TK-' + this.task.idWorldTask.toString(16).toUpperCase());
      this.$anm22.eventBus.$emit("world-headbar-show-message", {
        text: this.$anm22.strLang(
          this.lang,
          "Task id successfully copied",
          "Id task copiato con successo"
        ),
        type: "confirm"
      });
    }
  },
  created() {
    this.taskName = this.task.name;
  }
}
</script>

<style lang="scss" scoped>
.delete-button {
  margin-left:auto;
  margin-right:10px;
  align-items: center;
  padding: 5px;
  border-radius: 4px;
  flex-wrap: nowrap;
  cursor: pointer;
}
.hidden-input {
  cursor: pointer;
  border-radius: 4px;
  padding: 2px 5px;
  align-items: center;
  &:hover {
    background-color: #eee;
  }
}
.task-id {
  font-size:14px;
  color:#666;
  display:block;
  padding: 0px 5px 2px 5px;
  cursor: pointer;
}
</style>
